import './_social-icon.scss';
import './_social-icon.twig';
import './_social-icon-menu.twig';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faLinkedin, faYoutube, faFacebookSquare, faInstagram,
} from '@fortawesome/free-brands-svg-icons';

export const name = 'social-icon';

export function disable() {}

export function enable() {
  library.add(
    ...[
      faLinkedin,
      faYoutube,
      faFacebookSquare,
      faInstagram,
    ],
  );
  dom.watch();
}

export default enable;
